/**
 * KAN-987: страницы смет убраны. Их адреса из закладок и старых ссылок
 * уводят на дашборд. /estimates/:id сюда не входит: страница сама переводит
 * заказ на /orders/:id.
 */
export const LEGACY_ESTIMATE_PATHS: readonly string[] = [
  '/estimates',
  '/estimates/new',
  '/estimates/:id/compare',
  '/estimates/:id/collaborate',
];
